import useMediaQuery from '@mui/material/useMediaQuery';

import { theme } from '../styles';

export const useIsDesktop = (): boolean => {
  return useMediaQuery(theme.breakpoints.up('lg'));
};
